import React, { useEffect, useState } from 'react'
import { Container, Box, Flex } from '@chakra-ui/react'
import Blogs from './blogs'
import { BLOG_LIMIT } from '@constants/blog.constant'
import Pagination from '@components/pagination'
import { listBlogs } from '@lib/util/read-blog-handle'
import { useQuery } from '@tanstack/react-query'
import BlogFilter from './blog-filter'
import SkeletonListBlog from '@components/skeleton/skeleton-list-blog'
import HeadingTag from '@components/heading-tag'
import useAosAnimation from '@common/hooks/use-aos-animation'

type BlogFilter = {
  date?: string
}

const Read = () => {
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [filter, setFilter] = useState<BlogFilter>({
    date: undefined
  })
  const [contents, setContents] = useState<any[]>([])

  const { data, isLoading } = useQuery(
    ['blogs', currentPage, filter.date],
    () =>
      listBlogs({
        limit: BLOG_LIMIT,
        offset: (currentPage - 1) * BLOG_LIMIT,
        start_date: filter.date
      })
  )

  const { data: total } = useQuery(
    ['total-blogs', currentPage, filter.date],
    () => listBlogs({ start_date: filter.date })
  )

  useEffect(() => {
    if (data != null && data.length > 0) {
      const dataContents = data.map((b: any) => {
        return { ...b.content, ...b }
      })
      setContents([...dataContents])
    } else {
      setContents([])
    }
  }, [data])

  useAosAnimation({
    duration: 600,
    once: true
  })

  return (
    <Container mt={10} mb={28}>
      <HeadingTag style={{ textAlign: 'center' }} data-aos="fade-down">
        Read
      </HeadingTag>
      <BlogFilter setFilter={setFilter} filter={filter} />
      {isLoading && <SkeletonListBlog />}
      {data && (
        <Box w={'100%'} mt={10}>
          <Blogs blogItems={contents ?? []} />
        </Box>
      )}
      <Flex justifyContent={'center'} mt={10}>
        <Pagination
          totalCount={total?.length ?? 0}
          currentPage={currentPage}
          pageSize={BLOG_LIMIT}
          setCurrentPage={setCurrentPage}
        />
      </Flex>
    </Container>
  )
}

export default Read
